<section class="category-faqs" *ngIf="faqs && faqs.length > 0">
  <h3 class="circul mb-3" *ngIf="categoryTitle">{{ categoryTitle }}</h3>
  <div class="row">
    <div *ngFor="let faq of faqs" class="faq-item col-lg-6">
      <details>
        <summary>
          <strong>{{ faq.question }}</strong>
        </summary>
        <div class="faq-answer font-weight-light" [innerHTML]="faq.answer"></div>
      </details>
    </div>
  </div>
</section>
